import { get, post } from '@/helpers/httpHandler';

export default {
  retrieveRelationshipsWithCompany: () => get('/relationships/company'),

  retrieveRelationshipsWithPerson: () => get('/relationships/person'),

  retrieveRelationsHelp: (_, personId) => get(`/relations-help/${personId}`),

  store: (_, data) => post('/relations', data),

  update: (_, relation) => post('/relations-update', relation),

  remove: (_, data) => post('/relations-destroy', data)
};
